import '../assets/css/bootstrap.min.css'
import '../assets/css/style.css'
import '../assets/css/all.min.css'

import { Outlet } from "react-router-dom";
import Footer from "../Sections/Footer";
import Header from "../Sections/Header";

export default function MainLayout() {
    return(
        <>
            <Header/>
            <Outlet />
            <Footer/>
        </>
    )
}